import React, { useState } from "react";
import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "./Auth.css";

const Register = ({ setUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [company, setCompany] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const defaultPriceId = "price_1RatOcRvHo620RneKGNASUqx"; // Standard plan

  const validatePassword = (password) => {
    const minLength = 8;
    const hasNumber = /\d/.test(password);
    const hasSymbol = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
    return password.length >= minLength && hasNumber && hasSymbol;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      toast.error("Passwords do not match!");
      return;
    }
    if (!termsAccepted) {
      setError("Please accept the Terms of Service!");
      toast.error("Please accept the Terms of Service!");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password must be at least 8 characters long and include at least one number and one symbol.");
      toast.error("Password must be at least 8 characters long and include at least one number and one symbol.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await sendEmailVerification(user);
      toast.success("Registration successful! Please verify your email to continue.");

      const userData = {
        uid: user.uid,
        email: email,
        name: name,
        surname: surname,
        displayName: `${name} ${surname}`,
        company: company || null,
        createdAt: new Date().toISOString(),
        subscription: {
          status: "pending",
          plan: null,
          subscriptionId: null,
          customerId: null,
          updatedAt: null,
        },
        usage: {
          classificationsUsed: 0,
          monthStart: serverTimestamp(),
          classificationLimit: 150,
        },
      };

      await setDoc(doc(db, "users", user.uid), userData);

      navigate("/verify-email", {
        state: { userId: user.uid, email: user.email, priceId: defaultPriceId },
      });
    } catch (err) {
      const errorMessage =
        err.code === "auth/email-already-in-use"
          ? "This email is already registered."
          : "Registration failed—check your details!";
      setError(errorMessage);
      toast.error(errorMessage);
      console.error("Registration error:", err);
    }
  };

  const openTerms = (e) => {
    e.preventDefault();
    window.open("/terms", "terms", "width=595,height=800,scrollbars=yes,resizable=yes");
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Link to="/" className="auth-back">
        ← Back to Home
        </Link>
        <h1 className="auth-title">Register for Customs Pro AI</h1>
        <p className="auth-subtitle">
          Password must be at least 8 characters and include a number and a symbol.
        </p>

        <form onSubmit={handleRegister} className="auth-form">
          <div className="auth-row">
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="auth-input"
              required
            />
            <input
              type="text"
              placeholder="Surname"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              className="auth-input"
              required
            />
          </div>

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-input"
            required
          />
          <input
            type="text"
            placeholder="Company Name (Optional)"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            className="auth-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="auth-input"
            required
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="auth-input"
            required
          />

          <label className="auth-checkbox">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
            />
            <span>
              I agree to the{" "}
              <a href="/terms" onClick={openTerms}>
                Terms of Service
              </a>
            </span>
          </label>

          <button type="submit" className="auth-btn">
            Register
          </button>
          {error && <p className="auth-error">{error}</p>}
        </form>

        <p className="auth-footer">
          Got an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;